import { type QueryResolvers, AccessoryDrawerDisplay } from '../../../../../generated/graphql'
import { getAccessoryDrawerState } from '@edge/spark/io-dashboards'

export const accessoryDrawerStateResolver: QueryResolvers['accessoryDrawerState'] = async () => {
    console.debug('accessoryDrawerStateResolver deprecated, use accessoryDrawer store')
    const state = getAccessoryDrawerState()
    return state ? AccessoryDrawerDisplay.WidgetConfig : null
}
